export default __webpack_public_path__ + "static/media/SndLowerUDownBump.6857fc29.mp3";